import React, { useMemo } from 'react'
import { UseFormHandleSubmit } from 'react-hook-form'

import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import ModalFooter from 'LuxKit/Modal/ModalFooter'

interface Props {
  onSubmit: ReturnType<UseFormHandleSubmit<any>>
  deleteItem: () => void
  isLoading: boolean
}

function EditModalFooter(props: Props) {
  const { onSubmit, deleteItem, isLoading } = props
  const trashIcon = useMemo(() => <LineTrashAltIcon />, [])

  return (
    <ModalFooter
      primaryActionProps={{
        children: 'Save',
        disabled: isLoading,
        onClick: onSubmit,
      }}
      secondaryActionProps={{
        children: 'Delete',
        disabled: isLoading,
        onClick: deleteItem,
        startIcon: trashIcon,
      }}
    />
  )
}

export default EditModalFooter
